
import { get } from './apiClient';
import { TenantEntityResponse } from './types';

export const tenantEntitiesService = {
  async list(
    tenantId: string, 
    entityType: 'sit' | 'label' | 'policy',
    pageNumber: number = 1
  ): Promise<TenantEntityResponse> {
    const { data } = await get<TenantEntityResponse>(
      `tenants/${tenantId}/entities`,
      {
        params: {
          entityType,
          pageNumber
        }
      }
    );
    return data;
  },
};